const cardItems = [
  {
    title: '国产剧热播榜',
    desc: '《庆余年2》《与凤行》《长相思》等年度爆款一网打尽，追剧不迷路。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20costume%20drama%20scene%20with%20warm%20golden%20lighting%2C%20traditional%20architecture%20and%20flowing%20robes%2C%20cinematic%20composition%2C%20soft%20atmospheric%20haze%2C%20refined%20aesthetic%2C%20no%20text&width=600&height=400&seq=card-01-2026&orientation=landscape',
    stat: '120部热播中',
  },
  {
    title: '院线大片专区',
    desc: '最新上映的国内外大片高清呈现，足不出户享受影院级视听盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20empty%20red%20seats%2C%20large%20silver%20screen%20glowing%2C%20cinematic%20atmosphere%2C%20luxurious%20minimalist%20design%2C%20no%20text&width=600&height=400&seq=card-02-2026&orientation=landscape',
    stat: '860部院线大片',
  },
  {
    title: '日韩剧场精选',
    desc: '从治愈日剧到高能韩剧，精选口碑佳作，满足你的多元观影口味。',
    img: 'https://readdy.ai/api/search-image?query=Serene%20East%20Asian%20urban%20street%20scene%20at%20sunset%2C%20warm%20amber%20lighting%20on%20modern%20buildings%2C%20cherry%20blossom%20petals%2C%20cinematic%20composition%2C%20romantic%20atmosphere%2C%20no%20text&width=600&height=400&seq=card-03-2026&orientation=landscape',
    stat: '350部高分剧',
  },
  {
    title: '动漫番剧大全',
    desc: '热血、治愈、奇幻——热门国漫日漫一应俱全，追番党的快乐老家。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20cityscape%20with%20warm%20sunset%20sky%2C%20colorful%20illustration%20aesthetic%2C%20dynamic%20composition%2C%20modern%20animation%20art%2C%20energetic%20and%20colorful%20atmosphere%2C%20no%20text&width=600&height=400&seq=card-04-2026&orientation=landscape',
    stat: '2000+话连载',
  },
  {
    title: '综艺娱乐合集',
    desc: '热门综艺随时随地随心看，搞笑、音乐、旅行、竞技，承包你的快乐时光。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20stage%20performance%20with%20colorful%20lighting%20and%20dynamic%20energy%2C%20entertainment%20show%20atmosphere%2C%20warm%20spotlights%2C%20vibrant%20and%20lively%20composition%2C%20modern%20studio%20setting%2C%20no%20text&width=600&height=400&seq=card-05-2026&orientation=landscape',
    stat: '500+档节目',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">分类片库</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">按类型快速找到你想看的影片，每个分类都有精选高分作品等你发现。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 px-3 py-1 text-xs font-medium rounded-full bg-background-950/60 text-white whitespace-nowrap">
                  {item.stat}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold font-heading text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {cardItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative overflow-hidden sm:w-2/5 aspect-video sm:aspect-auto">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-3 left-3 px-3 py-1 text-xs font-medium rounded-full bg-background-950/60 text-white whitespace-nowrap">
                    {item.stat}
                  </div>
                </div>
                <div className="p-5 sm:w-3/5 flex flex-col justify-center">
                  <h3 className="text-base font-bold font-heading text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}